import { useFormContext } from 'react-hook-form';

import { type ButtonProps, Button } from '../button';

type FormButtonTypeProps =
  | { type?: 'submit' }
  | { type?: 'button'; onClick?: ButtonProps['onClick'] };

export type FormButtonProps = {
  color?: ButtonProps['color'];
  label: string;
  loading?: boolean;
  size?: ButtonProps['size'];
  variant?: ButtonProps['variant'];
  disabled?: boolean;
} & FormButtonTypeProps;

export default function FormButton(props: Readonly<FormButtonProps>) {
  const {
    label,
    type = 'submit',
    variant,
    loading: isLoading = false,
    size = 'medium',
    color,
    disabled: isDisabled = false,
  } = props;
  const { formState } = useFormContext();
  const { isDirty, isSubmitting, disabled: isFormStateDisabled } = formState;

  const onClick = 'onClick' in props ? props.onClick : undefined;

  return (
    <Button
      color={color}
      type={type}
      disabled={!isDirty || isFormStateDisabled || isDisabled}
      loading={isLoading || isSubmitting}
      variant={variant}
      size={size}
      onClick={onClick}
    >
      {label}
    </Button>
  );
}
